import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    ButtonBox,
    DownIcon,
    ImageBox,
    ItemBox,
    ItemTitle,
    ResultWrapper,
    ProductImg,
} from './ProductsResultViewStyle';
import placeholder from '../../../static/images/placeholder.jpg';
import ProductsSearchFilters from '../ProductsSearchFilters/ProductsSearchFilters';
import { Link } from 'gatsby';
import { ProductSearchResultsContext } from '../../../context/ProductSearchResultsContext';
import { urlForImage } from '../../../utils/urlForImage';
import { filterItems } from '../../../utils/filterItems';

const ProductsResultView = ({ numberOfItems }) => {
    const { t } = useTranslation();
    const { language } = useI18next();
    const [isVisible, setIsVisible] = useState(true);
    const { itemsOfProducts, currentOffset, setCurrentOffset } = useContext(ProductSearchResultsContext);
    const [products, setProducts] = useState([]);
    const firstImage = 0;

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        if (itemsOfProducts.length) {
            setProducts(filterItems(itemsOfProducts));
        }
    }, [itemsOfProducts]);

    const displayItems = () =>
        filterItems(itemsOfProducts)?.map((item: any, index: number) => (
            <ItemBox key={index}>
                <Link to={`/${language}${item?.url}`}>
                    <ImageBox>
                        <ProductImg
                            src={
                                item?.image?.length > 0
                                    ? urlForImage(item?.image[firstImage]?.field_media_image)
                                    : placeholder
                            }
                            alt={item?.image?.length > 0 ? item?.image[firstImage]?.alt : index}
                        />
                    </ImageBox>
                    <ItemTitle>{item?.title}</ItemTitle>
                </Link>
            </ItemBox>
        ));

    return (
        <>
            <ProductsSearchFilters />
            <ResultWrapper>{displayItems()}</ResultWrapper>
            {isVisible && products?.length >= currentOffset + numberOfItems && (
                <ButtonBox>
                    <Button
                        onClick={() => {
                            setCurrentOffset(currentOffset + numberOfItems);
                        }}
                    >
                        {t('loadMore')} <DownIcon />
                    </Button>
                </ButtonBox>
            )}
        </>
    );
};

export default ProductsResultView;
